// Curated bank of 8-character Nerdle equations.
// No leading zeros anywhere (real-Nerdle rule). Each entry is re-validated at
// module load by the equation validator; anything that fails is dropped, so
// it's safe to over-collect here.
import { isValidEquation } from '../lib/nerdle';

const RAW = [
  // Two-operand AB+CD=EF / AB-CD=EF
  '10+15=25','11+11=22','11+12=23','11+22=33','11+33=44','11+44=55',
  '11+55=66','11+66=77','11+77=88','11+88=99','12+13=25','12+34=46',
  '13+24=37','13+25=38','14+15=29','14+27=41','15+33=48','17+12=29',
  '18+15=33','21+13=34','22+13=35','22+33=55','23+24=47','25+13=38',
  '26+38=64','31+17=48','35+24=59','41+18=59','44+12=56','51+18=69',
  '55+11=66','71+18=89','81+12=93',
  '99-44=55','99-77=22','88-22=66','88-33=55','88-44=44','75-58=17',
  '91-23=68','84-25=59','78-25=53','77-25=52','65-31=34','50-15=35',
  '92-37=55','81-23=58','41-23=18','32-13=19','38-19=19','45-19=26',

  // AB*C=DEF (three-digit RHS)
  '12*9=108','13*8=104','14*8=112','15*7=105','16*7=112','18*6=108',
  '21*5=105','22*5=110','23*5=115','25*5=125','27*4=108','32*4=128',

  // A op B op C = DD (single-digit operands, two-digit RHS)
  '9+9+9=27','9+9+8=26','9+9+7=25','8+9+9=26','8+8+9=25','8+8+8=24',
  '7+7+9=23','7+8+8=23','6+9+9=24','5+9+9=23','4+9+9=22','3+9+9=21',
  '2+9+9=20','1+9+9=19',
  '9*9-7=74','9*9-1=80','9*9+1=82','9*8-7=65','9*8+1=73','8*8-7=57',
  '8*8+1=65','8*8-1=63','7*8-5=51','7*8+5=61','7*7+1=50','7*7-1=48',
  '6*7-5=37','6*7+8=50','5*9+5=50','4*9+5=41','3*9+5=32','2*9+5=23',
  '1*9+5=14','5*8-7=33','5*8+7=47','3*8+7=31','2*8+9=25',
  '9*2+1=19','9*2+3=21','9*2+5=23','9*2+7=25','9*2+9=27',
  '8*2+3=19','8*2+5=21','8*2+7=23','8*2+9=25',
  '9*3-2=25','9*3+1=28','9*3-4=23','9*4-9=27','9*4-5=31','9*4+1=37',
  '8*4-1=31','8*4+1=33','8*4-5=27','8*4-7=25',

  // A+B*C=DD with precedence
  '12+3*4=24','11+2*5=21','9+8*7=65','9+7*5=44','9+6*5=39',

  // Divisions yielding two-digit RHS
  '99/9+1=12','81/9+1=10','64/8+5=13','49/7+5=12','36/6+5=11','25/5+5=10',
  '16/4+8=12','81/9*2=18','64/8*2=16','49/7*3=21','36/6*5=30',

  // Symmetric small forms
  '1+2+3+4=10','2+3+4+5=14','3+4+5+6=18','4+5+6+7=22','5+6+7+8=26',
  '6+7+8+9=30'
];

const seen = new Set();
const list = [];
for (const eq of RAW) {
  if (eq.length !== 8) continue;
  if (seen.has(eq)) continue;
  if (!isValidEquation(eq)) continue;
  seen.add(eq);
  list.push(eq);
}

const NERDLE_LIST = list;
export default NERDLE_LIST;
export { NERDLE_LIST };
